import { render, staticRenderFns } from "./ResizableWorkspace.vue?vue&type=template&id=02ee6e54&scoped=true"
import script from "./ResizableWorkspace.vue?vue&type=script&lang=js"
export * from "./ResizableWorkspace.vue?vue&type=script&lang=js"
import style0 from "./ResizableWorkspace.vue?vue&type=style&index=0&id=02ee6e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee6e54",
  null
  
)

export default component.exports